import * as yup from "yup";

import type { TFunction } from "i18next";

/**
 * `projectId` sale como string: el `<Select>` de MUI entrega el id numérico del
 * `<MenuItem>` y `yup.string()` lo castea al validar. `total` no es
 * requerido por el schema: se recalcula vía `setValue` antes de enviar.
 */
export interface RegisterHourDescriptiveValues {
  projectId: string;
  hourProductive: number;
  hourPaidLeave: number;
  hourDisease: number;
  hourUnpaidLeave: number;
  total?: number;
}

/**
 * Construye el schema de validación para la carga descriptiva de horas.
 * Valida cada tipo de hora (productivas, vacaciones, enfermedad, licencia) y el
 * total; el total calculado no debe superar 40 horas semanales.
 */
export const buildRegisterHourDescriptiveSchema = (
  t: TFunction
): yup.ObjectSchema<RegisterHourDescriptiveValues> =>
  yup.object().shape({
    projectId: yup.string().typeError(t("isRequired")).required(t("isRequired")),
    hourProductive: yup
      .number()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .min(0)
      .max(40, t("notBeDaysLongerThan40")),
    hourPaidLeave: yup
      .number()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .min(0)
      .max(40, t("notBeDaysLongerThan40")),
    hourDisease: yup
      .number()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .min(0)
      .max(40, t("notBeDaysLongerThan40")),
    hourUnpaidLeave: yup
      .number()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .min(0)
      .max(40, t("notBeDaysLongerThan40")),
    total: yup.number().min(0).max(40, t("totalMustNotBeMoreThan40")),
  }).required();
